import { BadRequestError, ForbiddenError, HttpError, ValidationFailuresResponse } from "components/ServerValidationErrors";

import { IncomingStockNotificationApiUrl } from "env-config";
import { acquireAccessToken } from "./access-token-service";

const baseApiUrl = ():string => IncomingStockNotificationApiUrl().replace(/[/]$/, "");

export type guid = string;
//#region Type definitions

export type CreatePreAlertRequest = {
    fieldCompanyId: number;
    partitionId: guid;
    supplierId: number;
    destinationWarehouseId: number;
    requiredDate: string;
    reference: string | null;
    procurementNumber: string | null;
    comments: string | null;
    additionalData: KeyValuePair[] | null;
    items: CreatePreAlertItemRequest[];
};

export type CreatePreAlertItemRequest = {
    reference: string | null;
    partNumber: string | null;
    productId: number;    
    quantity: number;
    unitCost: number;
    currencyCode: string;
    additionalData: KeyValuePair[] | null;
};

export type KeyValuePair = {
    key: string;
    value: string | null;
};

export type CreatePreAlertResponse = {
};


//#endregion

async function apiFetch<TResponse>(path: string, options: RequestInit): Promise<TResponse|null> {
    const url = `${baseApiUrl()}${path}`;
    const accessToken = await acquireAccessToken("api://incoming-stock-notification-api", "access");
    const response = await fetch(url, {
        ...options,
        headers: { ...options.headers, Authorization: `Bearer ${accessToken}` },
    });
    if (response.ok) {
        if (response.status === 204) return null;
        return (await response.json()) as TResponse;         
    } else if (response.status === 400) {
        throw new BadRequestError(
            response.status,
            response.statusText,
            (await response.json()) as ValidationFailuresResponse
        );
    } else if (response.status === 403) {
        throw new ForbiddenError(response.status, await response.text());
    } else {
        throw new HttpError(response.status, await response.text());
    }
}

export async function createPreAlert(dto: CreatePreAlertRequest): Promise<void> {
    await apiFetch<CreatePreAlertResponse>('/incomingstocknotifications', {
        headers: { "Content-Type": "application/json" },
        method: 'POST',
        body: JSON.stringify(dto)
    });
}